import { ApiResponse, UserDetails, LanguageShort } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";
import Config from "../../../Configs";
import { UpdateProfileRequest } from "../../../Models/ServerModels/Auth/UpdateProfileRequest";

export default class UsersApiService extends ApiServiceBase {
  constructor(client: IHttpService) {
    super(client);
  }

  async updateUserProfile(request: UpdateProfileRequest): Promise<ApiResponse<UserDetails>> {
    return await this._client.patch<any>(Config.apiPaths.updateProfile, request);
  }

  async updateLanguage(language: string): Promise<ApiResponse<LanguageShort>> {
    return await this._client.get(Config.apiPaths.updateLanguage.replace("{0}", language));
  }
}
